import React from "react";

const SubHeader = ({ onDriversClick, onTracksClick }) => {
    return (
        <div className="subheader">
            <div className="text">
                <h1>Gear Up. DRS active. Overtake.<br/>Win the data race.</h1>
                <p>High quality visualisations designed for F1 nerds!</p>
            </div>

            <div className="button">
                <button onClick={onTracksClick}>Analyse a session</button>
                <button onClick={onDriversClick}>Track your favourite driver</button>
            </div>
        </div>
    )
}

export default SubHeader; 